import apiV2 from "api-v2";
import type {
	EvaluationPanelMember,
	AddPanelMemberPayload,
	SendInvitationsPayload,
	CompanyUser,
	AiPanelUser,
} from "../types/panel.type";

const unwrap = <T>(responseData: unknown): T => {
	if (responseData && typeof responseData === "object" && "data" in responseData) {
		return (responseData as Record<string, unknown>).data as T;
	}
	return responseData as T;
};

export const getPanelMembers = async (
	rfxId: number
): Promise<EvaluationPanelMember[]> => {
	const response = await apiV2.get(`/rfx/${rfxId}/evaluation/panel`, {
		params: { include_declined: true },
	});
	return unwrap<EvaluationPanelMember[]>(response.data) ?? [];
};

export const addPanelMember = async (
	rfxId: number,
	payload: AddPanelMemberPayload
): Promise<EvaluationPanelMember> => {
	const response = await apiV2.post(`/rfx/${rfxId}/evaluation/panel`, payload);
	return unwrap<EvaluationPanelMember>(response.data);
};

export const removePanelMember = async (
	rfxId: number,
	memberId: number
): Promise<void> => {
	await apiV2.delete(`/rfx/${rfxId}/evaluation/panel/${memberId}`);
};

export const sendPanelInvitations = async (
	rfxId: number,
	payload: SendInvitationsPayload
): Promise<{ sent: number }> => {
	const response = await apiV2.post(
		`/rfx/${rfxId}/evaluation/panel/invite`,
		payload
	);
	return unwrap<{ sent: number }>(response.data);
};

export const resendPanelInvitations = async (
	rfxId: number,
	memberIds: number[]
): Promise<{ sent: number }> => {
	const response = await apiV2.post(
		`/rfx/${rfxId}/evaluation/panel/resend`,
		{ member_ids: memberIds }
	);
	return unwrap<{ sent: number }>(response.data);
};

export const searchCompanyUsers = async (
	companyId: number,
	query: string
): Promise<CompanyUser[]> => {
	const response = await apiV2.get(`/company/${companyId}/users`, {
		params: { search: query },
	});
	return unwrap<CompanyUser[]>(response.data) ?? [];
};

export const getAiPanelUsers = async (
	rfxId: number
): Promise<AiPanelUser[]> => {
	const response = await apiV2.get(`/rfx/${rfxId}/evaluation/panel/ai-users`);
	return unwrap<AiPanelUser[]>(response.data) ?? [];
};
